/* eslint-disable @typescript-eslint/naming-convention */

// https://getbootstrap.com/docs/5.0/content/tables/

import type { TBorder, IChildrenProps } from '../definitions'

import './Table.css'

interface IProps extends IChildrenProps {
  readonly striped?: boolean
  readonly hover?: boolean
  readonly dark?: boolean
  readonly bordered?: boolean
  readonly responsive?: boolean
  readonly border?: TBorder
  readonly className?: string
}

/**
 * Egy BS Table komponens factory-ja.
 * @param props - JSX props {@link IProps}.
 */
export default function Table (props: IProps): HTMLElement {
  const cn: readonly string[] = [
    'table',
    props.hover === false ? '' : 'table-hover',
    props.striped ? 'table-striped' : '',
    props.dark ? 'table-dark' : '',
    props.bordered || props.border ? 'table-bordered' : '',
    props.border ? `border-${ props.border }` : '',
    props.className ?? ''
  ]

  const table: HTMLElement = <table className={ cn }>{ props.children }</table>

  if (props.responsive) {
    const parent: HTMLElement = (
      <div className="table-responsive">
        { table }
      </div>
    )

    return parent
  }

  return table
}
